<template>
  <div id="data-view">
    <dv-full-screen-container>
      <div class="block-top-header">
        <div style="width:40%;">
          <top-header name="topHeader" :PageTitle="PageTitle" ActiveMenuIndex="mainPage" />
        </div>
        <div style="width:60%;">
          <el-cascader id="selectedMonth" style="font-size:22px; width:350px; left: 250px;"
          v-model="selectedMonth"
          :options="optionsmonth"
          :props="propsMonth"
          placeholder="Month"
          collapse-tags
           @change="changeSelectComponent('selectedMonth'); refreshDataOnChange();"
          ></el-cascader>

          <el-select v-model="selectedArea" style="right:-250px; width:150px;" class="block-top-button-field" @change="refreshDataOnChange()">
            <el-option
              v-for="item in options2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select v-model="selectedBU" style="right:-300px;" class="block-top-button-field" placeholder="All BUs" @change="refreshDataOnChange()">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="block-top-line"></div>
      <div class="block-top-content">
        <div style="width:15%;">
          <water-level-chart ref="energyTotal" />
        </div>
        <div style="width:55%;">
          <energy ref="energyComponent" />
          <earth ref="earthComponent" />
        </div>
        <div style="width:30%;">
          <digital-flop ref="digitalFlop" />
          <echarts1 ref="energySankey" />
        </div>
      </div>
      <div class="block-top-line"></div>
      <div class="block-top-content-2">
        <barsh ref="barshComponent"></barsh>
      </div>
    </dv-full-screen-container>
  </div>
</template>

<script>
import topHeader from "../TopMenu/topHeader";
import digitalFlop from "./digitalFlop";
// import rankingBoard from "./rankingBoard";
// import roseChart from "./roseChart";
import energy from "./energy";
import earth from "./earth";
import barsh from "./barsh";
import waterLevelChart from "./waterLevelChart";
// import cards from "./cards";
import echarts1 from "./echarts1";
import { AREA_LIST, BU_LIST, BU_LIST2, MONTH_NAME } from "../mainPage/area_bu";

export default {
  name: "DataView",
  components: {
    topHeader,
    digitalFlop,
    // rankingBoard,
    // roseChart,
    energy,
    earth,
    barsh,
    waterLevelChart,
    // cards,
    echarts1,
  },
  data() {
    return {
      //PageTitle: '延锋能源信息中心',
      PageTitle: this.locale('Energy Management Information System','能源信息中心'),
      counter: 0,
      options: BU_LIST,
      options2: AREA_LIST,
      selectedBU: "",
      selectedMonth: [[2020, '2020-11']],
      selectedYear: "",
      value1: "",
      selectedArea: "SH",
      optionsmonth: [
        { value: "1", label: "1月" },
        { value: "2", label: "2月" },
        { value: "3", label: "3月" },
        { value: "4", label: "4月" },
        { value: "5", label: "5月" },
        { value: "6", label: "6月" },
        { value: "7", label: "7月" },
        { value: "8", label: "8月" },
        { value: "9", label: "9月" },
        { value: "10", label: "10月" },
        { value: "11", label: "11月" },
        { value: "12", label: "12月" },
      ],
      propsMonth: { multiple: true },
      optionsYear: [
        { value: "2019", label: "2019" },
        { value: "2020", label: "2020" },
      ],
    };
  },
  created() {
    this.optionsmonth = []
    const iNowYear = (new Date()).getFullYear()
    for (let i = iNowYear; i > iNowYear - 5; i--) {
      let itemYear = {
        label: i,
        value: i,
        children: []
      }
      for (let m = 0; m < MONTH_NAME.length; m++) {
        let itemMonth = {
          label: MONTH_NAME[m].label,
          value: i + '-' + MONTH_NAME[m].value
        }
        itemYear.children.push(itemMonth)
      }
      this.optionsmonth.push(itemYear)
    }

    this.selectedArea = this.options2[1].value;
    this.refreshDataOnChange();
  },
  methods: {
    changeBu() {
      if(this.selectedArea!=="SH"){
      this.options = BU_LIST2
      }else{
      this.options = BU_LIST
      }
    },
    setYearAndMonth(month, year) {
      console.log('setYearAndMonth')
      const { changeSelectComponent } = this

      this.selectedYear = year;
      if (this.selectedMonth.length == 0) {
        this.selectedMonth = [[year, year + '-' + month]];
      }
      changeSelectComponent('selectedMonth')
    },
    refreshDataOnChange(sender) {
      if (sender == 'calendar' || this.selectedMonth.length == 0) {
        return
      }
      this.selectedYear = ''
      const queryArgs = {
        QueryAreaName: this.selectedArea,
        QueryBU: this.selectedBU
      };
      if (this.selectedMonth.length > 0) {
        queryArgs.QueryYear = this.selectedMonth[0][0]
        let monthList = ''
        for (let i = 0; i < this.selectedMonth.length; i++) {
          monthList += this.selectedMonth[i][1].split('-')[1] + ','
        }
        if (monthList.length > 0) {
          monthList = monthList.substring(0, monthList.length - 1)
        }
        queryArgs.QueryStartMonth = monthList
      }
      console.log("queryArgs",queryArgs);
      this.$refs.energyComponent.refreshData(queryArgs);
      this.$refs.energyTotal.refreshData(queryArgs);
      this.$refs.earthComponent.refreshData(queryArgs);
      this.$refs.energySankey.refreshData(queryArgs);
      this.$refs.barshComponent.refreshData(queryArgs);
    },
    margin() {
      this.$router.push("/mainPage");
    },
    md() {
      this.$router.push("/MD");
    },
    svg() {
      this.$router.push("/MeterSVG");
    },
    bscpage1() {
      this.$router.push("/bscpage1");
    },
    bscpage2() {
      this.$router.push("/bscpage2");
    },
    emp1() {
      this.$router.push("/emp1");
    },
    emp2() {
      this.$router.push("/InjMold");
    },
    changeSelectComponent(id) {
      var obj = document.querySelector('#' + id + ' .el-cascader__tags')
      if (obj == null) {
        return
      }
      let monthList = ''
      let prevYear = ''
      for (let i = 0; i < this.selectedMonth.length; i++) {
        let item = this.selectedMonth[i]
        if (prevYear == '') {
          prevYear = item[0]
          monthList = item[0] + ' / '
        }
        if (prevYear != item[0]) {
          this.$message.error('不允许选择跨年！')
          return
        }
        monthList += item[1].split('-')[1] + ','
      }
      if (monthList.length > 4) {
        monthList = monthList.substring(0, monthList.length - 1)
      }
      document.querySelector('#' + id + ' .el-cascader__tags').innerHTML = monthList
    }
  },
};
</script>

<style lang="less">
#data-view {
  width: 100%;
  height: 100%;
  background-color: #17293d;
  color: #fff;

  #dv-full-screen-container {
    //background-image: url("./img/bg.png");
    background-image: url();
    background-color: #17293d;
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;
  }

  .block-top-header {
    width: 100%;
    display: flex;
    background-color: #1B2445;
  }

  .block-top-line {
    //background-color: #1D2647;
    background-color: #313C5E;
    width: 100%; 
    height: 4px;
    margin-left: 10px;
    margin-right: 10px;
  }

  .block-top-button {
    background-color: #253e5d;
    height: 50px;
  }

  .block-top-button-field {
    margin-top: 15px;
    margin-left: 10px;
  }

  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    background-color: #1B2445;
  }

  .block-left-right-content {
    flex: 1;
    display: flex;
    margin-top: 20px;
  }

  .block-top-bottom-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 0px;
  }

  .block-top-content {
    height: 60%;
    display: flex;
    position: relative;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 0px;
  }
  .block-top-content-2 {
    height: 30%;
    display: flex;
    position: relative;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 0px;
  }
}

.el-select .el-input__inner {
  background-color: rgba(0, 0, 0, 0) !important;
  border: 0;
  color: #ffffff;
  font-size: 22px;
}
.el-cascader .el-input__inner {
  background-color: rgba(0, 0, 0, 0) !important;
  border: 0;
  color: #ffffff;
}
.el-cascader .el-cascader__tags .el-tag {
  background-color: rgba(0, 0, 0, 0) !important;
  border: 0;
  color: #ffffff;
}

</style>
